core.constant('alabMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "MODULE": {
        "ALAB": {
          "DOCTOR": "Lekarz",
          "FILES": "Pliki",
          "EXECUTE": "Zrealizuj",
          "CREATION_DATE": "Data zlecenia",
          "EXECUTE_CONFIRMATION_TEXT": "Czy na pewno chcesz oznaczyć te badania jako zrealizowane?",
          "REVERT_EXECUTION": "Cofnij"
        }
      }
    },
    "ENUM": {
      "ALAB_TERM": {
        "PRERESERVATION": "Czeka na potwierdzenie",
        "RESERVATION": "Zlecone",
        "DONE": "Zrealizowane"
      }
    }
  }
});


